// 操作日志
const OperateLogRouter =  {
  path: 'operateLog',
  name: 'OperateLog',
  meta: {
    requiresAuth: false,
    leftMenu: true
  },
  component: () => import('@/views/Setting/operateLog')
}
export default OperateLogRouter
